import React from 'react';

import { Typography, Box, Button } from '@mui/material';
import "./Title.css";
import { useNavigate } from 'react-router-dom';

export const Title = () => {
  const navigate = useNavigate();
  return (
    <Box className="Title11">
      <Typography className='TilteText'>Home</Typography>
      <Box sx= {{display:"flex",gap:"10px"}}>
      <Button className="hover" sx={{ background: "#EC492F", height: "32px" }} onClick={() => navigate("/CreateChannel")} >
        <Typography className="button1">
          Create Channel
        </Typography>
      </Button>
      <Button className="hover" sx={{ background: "#EC492F", height: "32px" }} onClick={() => navigate("/genapikey")} >
        <Typography className="button1">
          Manage-Api-keys
        </Typography>
      </Button>
      </Box>
    </Box>
  );
};